(function($) {
/**
 * GENERATED FILE — do not edit. Run `npm run icons` to regenerate.
 *
 * Maps an icon set's CSS class name to the codepoint of the glyph it renders,
 * so {@link OpenSeadragon.FlexRenderer.UIControls.IconLibrary} can rasterize
 * icons with only the webfont loaded — the icon stylesheet is not required.
 *
 * Sources: @phosphor-icons/web 2.1.2, @fortawesome/fontawesome-free 6.7.2
 */
$.FlexRenderer.UIControls.IconCodepoints = {
    "fa-brands fa-apple": 0xf179,
    "fa-brands fa-chrome": 0xf268,
    "fa-brands fa-css3-alt": 0xf38b,
    "fa-brands fa-discord": 0xf392,
    "fa-brands fa-docker": 0xf395,
    "fa-brands fa-edge": 0xf282,
    "fa-brands fa-figma": 0xf799,
    "fa-brands fa-firefox": 0xf269,
    "fa-brands fa-github": 0xf09b,
    "fa-brands fa-gitlab": 0xf296,
    "fa-brands fa-google": 0xf1a0,
    "fa-brands fa-html5": 0xf13b,
    "fa-brands fa-js": 0xf3b8,
    "fa-brands fa-linux": 0xf17c,
    "fa-brands fa-node-js": 0xf3d3,
    "fa-brands fa-npm": 0xf3d4,
    "fa-brands fa-python": 0xf3e2,
    "fa-brands fa-slack": 0xf198,
    "fa-brands fa-windows": 0xf17a,
    "fa-brands fa-x-twitter": 0xe61b,
    "fa-regular fa-bell": 0xf0f3,
    "fa-regular fa-bookmark": 0xf02e,
    "fa-regular fa-calendar": 0xf133,
    "fa-regular fa-circle": 0xf111,
    "fa-regular fa-circle-question": 0xf059,
    "fa-regular fa-circle-user": 0xf2bd,
    "fa-regular fa-clock": 0xf017,
    "fa-regular fa-file": 0xf15b,
    "fa-regular fa-file-lines": 0xf15c,
    "fa-regular fa-folder": 0xf07b,
    "fa-regular fa-heart": 0xf004,
    "fa-regular fa-image": 0xf03e,
    "fa-regular fa-message": 0xf27a,
    "fa-regular fa-square": 0xf0c8,
    "fa-regular fa-star": 0xf005,
    "fa-solid fa-backward": 0xf04a,
    "fa-solid fa-bolt": 0xf0e7,
    "fa-solid fa-bookmark": 0xf02e,
    "fa-solid fa-brush": 0xf55d,
    "fa-solid fa-bug": 0xf188,
    "fa-solid fa-bullseye": 0xf140,
    "fa-solid fa-calendar": 0xf133,
    "fa-solid fa-camera": 0xf030,
    "fa-solid fa-chart-line": 0xf201,
    "fa-solid fa-chart-pie": 0xf200,
    "fa-solid fa-check": 0xf00c,
    "fa-solid fa-circle": 0xf111,
    "fa-solid fa-circle-info": 0xf05a,
    "fa-solid fa-circle-question": 0xf059,
    "fa-solid fa-clock": 0xf017,
    "fa-solid fa-cloud": 0xf0c2,
    "fa-solid fa-cloud-rain": 0xf73d,
    "fa-solid fa-copy": 0xf0c5,
    "fa-solid fa-crop": 0xf125,
    "fa-solid fa-crosshairs": 0xf05b,
    "fa-solid fa-database": 0xf1c0,
    "fa-solid fa-dna": 0xf471,
    "fa-solid fa-download": 0xf019,
    "fa-solid fa-droplet": 0xf043,
    "fa-solid fa-envelope": 0xf0e0,
    "fa-solid fa-eye": 0xf06e,
    "fa-solid fa-eye-slash": 0xf070,
    "fa-solid fa-file": 0xf15b,
    "fa-solid fa-file-lines": 0xf15c,
    "fa-solid fa-filter": 0xf0b0,
    "fa-solid fa-fire": 0xf06d,
    "fa-solid fa-flag": 0xf024,
    "fa-solid fa-flask": 0xf0c3,
    "fa-solid fa-folder": 0xf07b,
    "fa-solid fa-forward": 0xf04e,
    "fa-solid fa-gear": 0xf013,
    "fa-solid fa-gem": 0xf3a5,
    "fa-solid fa-heart": 0xf004,
    "fa-solid fa-hospital": 0xf0f8,
    "fa-solid fa-house": 0xf015,
    "fa-solid fa-image": 0xf03e,
    "fa-solid fa-layer-group": 0xf5fd,
    "fa-solid fa-leaf": 0xf06c,
    "fa-solid fa-link": 0xf0c1,
    "fa-solid fa-location-dot": 0xf3c5,
    "fa-solid fa-lock": 0xf023,
    "fa-solid fa-magnifying-glass": 0xf002,
    "fa-solid fa-microscope": 0xf610,
    "fa-solid fa-minus": 0xf068,
    "fa-solid fa-moon": 0xf186,
    "fa-solid fa-music": 0xf001,
    "fa-solid fa-palette": 0xf53f,
    "fa-solid fa-paste": 0xf0ea,
    "fa-solid fa-pause": 0xf04c,
    "fa-solid fa-pen": 0xf304,
    "fa-solid fa-phone": 0xf095,
    "fa-solid fa-pills": 0xf484,
    "fa-solid fa-play": 0xf04b,
    "fa-solid fa-plus": 0x2b,
    "fa-solid fa-ruler": 0xf545,
    "fa-solid fa-scissors": 0xf0c4,
    "fa-solid fa-seedling": 0xf4d8,
    "fa-solid fa-server": 0xf233,
    "fa-solid fa-share-nodes": 0xf1e0,
    "fa-solid fa-shield-halved": 0xf3ed,
    "fa-solid fa-sliders": 0xf1de,
    "fa-solid fa-snowflake": 0xf2dc,
    "fa-solid fa-square": 0xf0c8,
    "fa-solid fa-star": 0xf005,
    "fa-solid fa-stethoscope": 0xf0f1,
    "fa-solid fa-stop": 0xf04d,
    "fa-solid fa-sun": 0xf185,
    "fa-solid fa-syringe": 0xf48e,
    "fa-solid fa-table-cells": 0xf00a,
    "fa-solid fa-tag": 0xf02b,
    "fa-solid fa-trash": 0xf1f8,
    "fa-solid fa-triangle-exclamation": 0xf071,
    "fa-solid fa-umbrella": 0xf0e9,
    "fa-solid fa-unlock": 0xf09c,
    "fa-solid fa-upload": 0xf093,
    "fa-solid fa-user": 0xf007,
    "fa-solid fa-users": 0xf0c0,
    "fa-solid fa-video": 0xf03d,
    "fa-solid fa-xmark": 0xf00d,
    "ph ph-apple-logo": 0xe516,
    "ph ph-bell": 0xe0ce,
    "ph ph-bookmark-simple": 0xe0ea,
    "ph ph-bug": 0xe5f4,
    "ph ph-calendar": 0xe108,
    "ph ph-camera": 0xe10e,
    "ph ph-chart-line": 0xe154,
    "ph ph-chart-pie": 0xe158,
    "ph ph-chat-circle": 0xe168,
    "ph ph-check": 0xe182,
    "ph ph-circle": 0xe18a,
    "ph ph-clipboard": 0xe196,
    "ph ph-clock": 0xe19a,
    "ph ph-cloud": 0xe1aa,
    "ph ph-cloud-rain": 0xe1b4,
    "ph ph-codepen-logo": 0xe978,
    "ph ph-copy": 0xe1ca,
    "ph ph-crop": 0xe1d4,
    "ph ph-crosshair": 0xe1d6,
    "ph ph-database": 0xe1de,
    "ph ph-diamond": 0xe1ec,
    "ph ph-discord-logo": 0xe61a,
    "ph ph-dna": 0xe924,
    "ph ph-download-simple": 0xe20c,
    "ph ph-drop": 0xe210,
    "ph ph-envelope": 0xe214,
    "ph ph-eye": 0xe220,
    "ph ph-eye-slash": 0xe224,
    "ph ph-fast-forward": 0xe6a6,
    "ph ph-figma-logo": 0xe22e,
    "ph ph-file": 0xe230,
    "ph ph-file-css": 0xeb34,
    "ph ph-file-html": 0xeb38,
    "ph ph-file-js": 0xeb24,
    "ph ph-file-text": 0xe23a,
    "ph ph-fire": 0xe242,
    "ph ph-flag": 0xe244,
    "ph ph-flask": 0xe79e,
    "ph ph-folder": 0xe24a,
    "ph ph-funnel": 0xe266,
    "ph ph-gear": 0xe270,
    "ph ph-github-logo": 0xe576,
    "ph ph-gitlab-logo": 0xe694,
    "ph ph-google-chrome-logo": 0xe976,
    "ph ph-google-logo": 0xe292,
    "ph ph-grid-four": 0xe296,
    "ph ph-hard-drives": 0xe2a0,
    "ph ph-heart": 0xe2a8,
    "ph ph-hospital": 0xe844,
    "ph ph-house": 0xe2c2,
    "ph ph-image": 0xe2ca,
    "ph ph-info": 0xe2ce,
    "ph ph-leaf": 0xe2da,
    "ph ph-lightning": 0xe2de,
    "ph ph-link": 0xe2e2,
    "ph ph-linkedin-logo": 0xe2ee,
    "ph ph-linux-logo": 0xeb02,
    "ph ph-lock": 0xe2fa,
    "ph ph-lock-open": 0xe306,
    "ph ph-magnifying-glass": 0xe30c,
    "ph ph-map-pin": 0xe316,
    "ph ph-microscope": 0xec7a,
    "ph ph-minus": 0xe32a,
    "ph ph-moon": 0xe330,
    "ph ph-music-note": 0xe33c,
    "ph ph-open-ai-logo": 0xe7d2,
    "ph ph-paint-brush": 0xe6f0,
    "ph ph-palette": 0xe6c8,
    "ph ph-pause": 0xe39e,
    "ph ph-pencil": 0xe3ae,
    "ph ph-phone": 0xe3b8,
    "ph ph-pill": 0xe700,
    "ph ph-plant": 0xebae,
    "ph ph-play": 0xe3d0,
    "ph ph-plus": 0xe3d4,
    "ph ph-question": 0xe3e8,
    "ph ph-reddit-logo": 0xe59c,
    "ph ph-rewind": 0xe6a8,
    "ph ph-ruler": 0xe6b8,
    "ph ph-scissors": 0xeae0,
    "ph ph-share-network": 0xe408,
    "ph ph-shield-check": 0xe40c,
    "ph ph-slack-logo": 0xe5a8,
    "ph ph-sliders": 0xe432,
    "ph ph-snowflake": 0xe5aa,
    "ph ph-square": 0xe45e,
    "ph ph-stack": 0xe466,
    "ph ph-stack-overflow-logo": 0xeb78,
    "ph ph-star": 0xe46a,
    "ph ph-stethoscope": 0xe7ea,
    "ph ph-stop": 0xe46c,
    "ph ph-sun": 0xe472,
    "ph ph-syringe": 0xe968,
    "ph ph-tag": 0xe478,
    "ph ph-target": 0xe47c,
    "ph ph-trash": 0xe4a6,
    "ph ph-umbrella": 0xe684,
    "ph ph-upload-simple": 0xe4c0,
    "ph ph-user": 0xe4c2,
    "ph ph-user-circle": 0xe4c4,
    "ph ph-users": 0xe4d6,
    "ph ph-video-camera": 0xe4da,
    "ph ph-warning": 0xe4e0,
    "ph ph-windows-logo": 0xe692,
    "ph ph-x": 0xe4f6,
    "ph ph-x-logo": 0xe4bc,
    "ph ph-youtube-logo": 0xe4fc,
    "ph-fill ph-bell": 0xe0ce,
    "ph-fill ph-bookmark-simple": 0xe0ea,
    "ph-fill ph-bug": 0xe5f4,
    "ph-fill ph-calendar": 0xe108,
    "ph-fill ph-camera": 0xe10e,
    "ph-fill ph-chart-line": 0xe154,
    "ph-fill ph-chart-pie": 0xe158,
    "ph-fill ph-chat-circle": 0xe168,
    "ph-fill ph-check": 0xe182,
    "ph-fill ph-circle": 0xe18a,
    "ph-fill ph-clipboard": 0xe196,
    "ph-fill ph-clock": 0xe19a,
    "ph-fill ph-cloud": 0xe1aa,
    "ph-fill ph-cloud-rain": 0xe1b4,
    "ph-fill ph-copy": 0xe1ca,
    "ph-fill ph-crop": 0xe1d4,
    "ph-fill ph-crosshair": 0xe1d6,
    "ph-fill ph-database": 0xe1de,
    "ph-fill ph-diamond": 0xe1ec,
    "ph-fill ph-dna": 0xe924,
    "ph-fill ph-download-simple": 0xe20c,
    "ph-fill ph-drop": 0xe210,
    "ph-fill ph-envelope": 0xe214,
    "ph-fill ph-eye": 0xe220,
    "ph-fill ph-eye-slash": 0xe224,
    "ph-fill ph-fast-forward": 0xe6a6,
    "ph-fill ph-file": 0xe230,
    "ph-fill ph-file-text": 0xe23a,
    "ph-fill ph-fire": 0xe242,
    "ph-fill ph-flag": 0xe244,
    "ph-fill ph-flask": 0xe79e,
    "ph-fill ph-folder": 0xe24a,
    "ph-fill ph-funnel": 0xe266,
    "ph-fill ph-gear": 0xe270,
    "ph-fill ph-grid-four": 0xe296,
    "ph-fill ph-hard-drives": 0xe2a0,
    "ph-fill ph-heart": 0xe2a8,
    "ph-fill ph-hospital": 0xe844,
    "ph-fill ph-house": 0xe2c2,
    "ph-fill ph-image": 0xe2ca,
    "ph-fill ph-info": 0xe2ce,
    "ph-fill ph-leaf": 0xe2da,
    "ph-fill ph-lightning": 0xe2de,
    "ph-fill ph-link": 0xe2e2,
    "ph-fill ph-lock": 0xe2fa,
    "ph-fill ph-lock-open": 0xe306,
    "ph-fill ph-magnifying-glass": 0xe30c,
    "ph-fill ph-map-pin": 0xe316,
    "ph-fill ph-microscope": 0xec7a,
    "ph-fill ph-minus": 0xe32a,
    "ph-fill ph-moon": 0xe330,
    "ph-fill ph-music-note": 0xe33c,
    "ph-fill ph-paint-brush": 0xe6f0,
    "ph-fill ph-palette": 0xe6c8,
    "ph-fill ph-pause": 0xe39e,
    "ph-fill ph-pencil": 0xe3ae,
    "ph-fill ph-phone": 0xe3b8,
    "ph-fill ph-pill": 0xe700,
    "ph-fill ph-plant": 0xebae,
    "ph-fill ph-play": 0xe3d0,
    "ph-fill ph-plus": 0xe3d4,
    "ph-fill ph-question": 0xe3e8,
    "ph-fill ph-rewind": 0xe6a8,
    "ph-fill ph-ruler": 0xe6b8,
    "ph-fill ph-scissors": 0xeae0,
    "ph-fill ph-share-network": 0xe408,
    "ph-fill ph-shield-check": 0xe40c,
    "ph-fill ph-sliders": 0xe432,
    "ph-fill ph-snowflake": 0xe5aa,
    "ph-fill ph-square": 0xe45e,
    "ph-fill ph-stack": 0xe466,
    "ph-fill ph-star": 0xe46a,
    "ph-fill ph-stethoscope": 0xe7ea,
    "ph-fill ph-stop": 0xe46c,
    "ph-fill ph-sun": 0xe472,
    "ph-fill ph-syringe": 0xe968,
    "ph-fill ph-tag": 0xe478,
    "ph-fill ph-target": 0xe47c,
    "ph-fill ph-trash": 0xe4a6,
    "ph-fill ph-umbrella": 0xe684,
    "ph-fill ph-upload-simple": 0xe4c0,
    "ph-fill ph-user": 0xe4c2,
    "ph-fill ph-user-circle": 0xe4c4,
    "ph-fill ph-users": 0xe4d6,
    "ph-fill ph-video-camera": 0xe4da,
    "ph-fill ph-warning": 0xe4e0,
    "ph-fill ph-x": 0xe4f6
};

})(OpenSeadragon);
